/* app/js/src/components/tenant/choose-template/side-menu/side-menu.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.search-input-wrapper {
  width: 200px;
  border: 1px solid #879baf;
  border-radius: 4px;
  margin: 9px 0 50px 90px;
}
.categories-list {
  list-style-type: none;
  color: #232f3a;
  font-size: 16px;
  margin-left: 50px;
}
.categories-list .categories-header {
  font-weight: bold;
}
.categories-list li {
  padding-top: 5px;
  padding-bottom: 5px;
}
.categories-list li:hover:not(.categories-header) {
  color: #40c1fe;
  cursor: pointer;
}
.categories-list li.active {
  color: #40c1fe;
  outline: none;
}
.categories-list li:focus {
  outline: 0;
}
/*# sourceMappingURL=side-menu.component.css.map */
